export default ".logo{text-align:left}";